import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BannerUpdate from '../BannerUpdate/BannerUpadate';
import './Examresult.css'; // Import the new CSS file
import API_URL from '../../api/ExamCalendarApi';

const ExamResults = () => {
  const [exams, setExams] = useState([]);
  const [title, setTitle] = useState('');
  const [pdfFile, setPdfFile] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchExams();
  }, []);

  const fetchExams = async () => {
    try {
      const response = await axios.get(`${API_URL}/examresult/all`);
      setExams(response.data);
    } catch (error) {
      console.error('Error fetching exam results:', error);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.name === 'pdf') {
      setPdfFile(e.target.files[0]);
    } else if (e.target.name === 'image') {
      setImageFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('title', title);
    if (pdfFile) {
      formData.append('pdf', pdfFile);
    }
    if (imageFile) {
      formData.append('bannerImage', imageFile);
    }

    try {
      if (editId) {
        await axios.put(`${API_URL}/examresult/edit/${editId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setEditId(null);
      } else {
        await axios.post(`${API_URL}/examresult/add`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }
      setTitle('');
      setPdfFile(null);
      setImageFile(null);
      fetchExams();
    } catch (error) {
      console.error('Error submitting exam result:', error);
    }
  };

  const handleEdit = (exam) => {
    setTitle(exam.title);
    setEditId(exam._id);
    window.scrollTo(0, 1000);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/examresult/delete/${id}`);
      fetchExams();
    } catch (error) {
      console.error('Error deleting exam result:', error);
    }
  };

  return (
    <div className="admin-examresult-container">
      <div className="admin-examresult-section">
        <h2 className="admin-examresult-heading">Exam Results</h2>
        <BannerUpdate pageName="examResults" />

        <form onSubmit={handleSubmit} className="admin-examresult-form">
          <div className="admin-examresult-form-group">
            <label htmlFor="title" className="admin-examresult-label">Title</label>
            <input
              type="text"
              className="admin-examresult-input"
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div className="admin-examresult-form-group">
            <label htmlFor="pdf" className="admin-examresult-label">PDF Upload</label>
            <input
              type="file"
              className="admin-examresult-input"
              id="pdf"
              name="pdf"
              onChange={handleFileChange}
            />
          </div>

          <div className="admin-examresult-form-group">
            <label htmlFor="image" className="admin-examresult-label">Image Upload (optional)</label>
            <input
              type="file"
              className="admin-examresult-input"
              id="image"
              name="image"
              onChange={handleFileChange}
            />
          </div>

          <button type="submit" className="admin-examresult-button">
            {editId ? 'Update' : 'Add'} Exam Result
          </button>
        </form>

        <h3 className="admin-examresult-subheading">Existing Exam Results</h3>
        <div className="admin-examresult-table-wrapper">
        <table className="admin-examresult-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>PDF Link</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {exams.map((exam) => (
              <tr key={exam._id}>
                <td>{exam.title}</td>
                <td><a href={exam.pdfLink} target="_blank" rel="noopener noreferrer">View PDF</a></td>
                <td>
                  {exam.bannerImage && <img src={exam.bannerImage} alt="Exam Result" className="admin-examresult-image" />}
                </td>
                <td className="admin-examresult-actions">
                  <button className="admin-examresult-edit-button" onClick={() => handleEdit(exam)}>Edit</button>
                  <button className="admin-examresult-delete-button" onClick={() => handleDelete(exam._id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
};

export default ExamResults;
